import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  webServices: [],
  dtos: []
}

export const getters = {
  webServices: state => state.webServices,
  dtos: state => state.dtos
}

export const mutations = {
  setWebServices (state, webServices) {
    state.webServices = webServices
  },
  setDtos (state, dtos) {
    state.dtos = dtos
  }
}

export const actions = {
  async getWebServices (context) {
    let error, response
    [error, response] = await to(api.getWebServices(context.rootGetters.application))
    if (error || !response) return

    context.commit('setWebServices', response.data.list)
  },

  async getDtos (context) {
    let error, response
    [error, response] = await to(api.getDtos(context.rootGetters.application))
    if (error || !response) return

    context.commit('setDtos', response.data.list)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
